import React, {Component} from 'react';
import {Form, Icon, message, Modal} from "antd";
import UploadWall from "../../../../components/upload/UploadWall";
import {
    PIC_TYPE_ORIGINAL,
    PIC_TYPE,

} from "../../../../constants";

import BaseComponent from "../../../../base/BaseComponent";
const accept = PIC_TYPE_ORIGINAL.map(item=>("."+item)).join(",")


class ShowIcon extends BaseComponent {

    static defaultProps = {
        showAddBtn: true,
        height: 280
    };

    constructor(props) {
        super(props);
        this.state={
            fileList:props.itemValue || [],
            maxSize: 1024 * 1024 * 1024 * 2  // 2GB
        }
    }

    checkData(){
        let {fileList} = this.state;
        for(let i = 0; i < fileList.length; i++){
            let file = fileList[i];
            if(!file.url){
                message.destroy();
                let name = file.name || file.originFileObj.name;
                message.warning(`${name}尚未上传完成，请等待所有文件上传完成！`);
                return false;
            }
        }
        return true;
    }



    render() {
        //newFileType类型只有小写，没有大写
        return (
            <Form.Item label={this.props.label} required={this.props.empty} style={{display:"flex",width:'200px',alignItems:'center'}}>
                <UploadWall
                    style={{ width: "auto" }}
                    accept={accept}
                    beforeUpload={this.handleBeforeUpload}
                    multiple={true}
                    action="/dynamic/storage/uploadFile"
                    showUploadBtn={true}
                    uploadBtnName={<div className='header-img'>
                        <img  src={this.props.itemValue} alt="" style={{objectFit: 'cover',width:'60px',height:'60px',borderRadius:'50%'}} />
                    </div>}
                    listType="list"
                    onChange={this.handleChange}
                />


            </Form.Item>
        )
    }

    //上传前添加上传提示，限制非格式的上传
    handleBeforeUpload = (file, fileList) => {
        let fileName = file.name.split('.');
        let upload = fileName.at(-1).toUpperCase();
        upload = PIC_TYPE.includes(upload);
        if(!upload){
            message.error('暂不支持该文件类型!');
        }
        return new Promise((resolve, reject) => {
            if (!upload) {
                reject(file);
            } else {
                resolve(file);
            }
        });
    };
    handleChange = info => {
        if (info.file.status === 'uploading') {
            return;
        }
        if (info.file.status === 'done') {
            this.props.callBack(info.file.response.data.smallPath);
        }
    };
}

export default ShowIcon;
